<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <g clip-path="url(#clip0_7423_34018)">
      <path
        d="M4 25.333C8.444 22.6663 10.6667 19.9997 10.6667 17.333C10.6667 13.333 9.33333 13.333 8 13.333C6.66667 13.333 5.29067 14.7797 5.33333 17.333C5.37867 20.0637 7.544 21.169 8.66667 22.6663C10.6667 25.333 12 25.9997 13.3333 23.9997C14.2227 22.6663 14.8893 21.5557 15.3333 20.6663C16.6667 23.777 18.444 25.333 20.6667 25.333H24"
        stroke="#F54308"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.6663 22.6667V6.66667C26.6663 5.172 25.4943 4 23.9997 4C22.505 4 21.333 5.172 21.333 6.66667V22.6667L23.9997 25.3333L26.6663 22.6667Z"
        stroke="#F54308"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.333 9.33301H26.6663"
        stroke="#F54308"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7423_34018">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
